module.exports = __webpack_public_path__ + "static/img/auto-bell-web-img@m.97d8a6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/glovis-aa/auto-bell-web-img@m.png
// module id = VBU3
// module chunks = 0